import {
  commonTexts,
  formatPriceListDiscountLabel,
  type PriceListDiscount,
  type PriceListDiscountLabelTexts
} from 'noddi-util';

type Props = PriceListDiscount & {
  translations?: PriceListDiscountLabelTexts;
};

export const PriceListDiscountLabel = ({
  priceListName,
  discountPercent,
  contextPriceListName,
  translations
}: Props) => {
  const text = formatPriceListDiscountLabel({
    priceListName,
    discountPercent,
    contextPriceListName,
    texts: translations ?? commonTexts.priceListDiscountLabel
  });
  if (!text) {
    return null;
  }
  return <span className='block text-xs text-muted-foreground'>{text}</span>;
};
